import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
import logoSeizoS from '../images/svg/logo_seizo_s.svg';
import logoSeizoNom from '../images/svg/logo_seizo_nom.svg';

const API_URL = process.env.REACT_APP_API_URL || '';

const getCookie = (name) => {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let c of ca) {
        c = c.trim();
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
};

const AbonnementSuccess = () => {
    const history   = useHistory();
    const location  = useLocation();
    const [status,    setStatus]    = useState('loading');
    const [email,     setEmail]     = useState('');
    const [isUpgrade, setIsUpgrade] = useState(false);

    useEffect(() => {
        const params    = new URLSearchParams(location.search);
        const sessionId = params.get('session_id');
        const userToken = getCookie('user_apiToken');
        setIsUpgrade(!!userToken);

        if (!sessionId) { setStatus('error'); return; }

        const headers = userToken ? { Authorization: 'Bearer ' + userToken } : {};
        axios.get(API_URL + '/api/stripe/checkout/status?session_id=' + sessionId, { headers })
            .then(res => {
                if (res.data.status === 'paid' || res.data.status === 'no_payment_required') {
                    setEmail(res.data.customer_email || '');
                    setStatus('success');
                    if (userToken) {
                        setTimeout(() => history.push('/pricing?success=1'), 3000);
                    }
                } else {
                    setStatus('error');
                }
            })
            .catch(() => {
                // En cas d'erreur API (ex: mismatch clé test/live), afficher succès quand même
                // Le webhook Stripe aura traité le paiement de son côté
                setStatus('success');
                if (userToken) {
                    setTimeout(() => history.push('/pricing?success=1'), 3000);
                }
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const BG = '#f5f7fa';
    const cardStyle = {
        background: '#fff',
        border: '1px solid #e8eef3',
        borderRadius: '24px', padding: '3rem 2.5rem',
        maxWidth: '540px', width: '100%', textAlign: 'center',
        boxShadow: '0 4px 24px rgba(0,35,53,0.08)',
    };
    const btnBlue = {
        width: '100%', background: '#00B0FF', color: '#fff',
        border: 'none', borderRadius: '12px', padding: '1rem',
        fontWeight: 700, fontSize: '1rem', cursor: 'pointer',
        boxShadow: '0 4px 16px rgba(0,176,255,0.3)',
    };
    const infoBox = {
        background: '#f0f8ff', borderRadius: '12px', padding: '1rem 1.2rem',
        marginBottom: '2rem', fontSize: '0.88rem', color: '#4a6070', lineHeight: 1.8,
        textAlign: 'left', border: '1px solid #d0eaf8',
    };

    return (
        <div style={{ minHeight: '100vh', background: BG, fontFamily: '"Nunito", sans-serif',
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '3rem', cursor: 'pointer' }}
                onClick={() => history.push('/')}>
                <img src={logoSeizoS}   alt="S"     style={{ height: '36px' }} />
                <img src={logoSeizoNom} alt="SEIZO" style={{ height: '20px' }} />
            </div>

            {status === 'loading' && (
                <div style={{ textAlign: 'center', color: '#4a6070' }}>
                    <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⏳</div>
                    <p style={{ color: '#4a6070' }}>Vérification du paiement en cours...</p>
                </div>
            )}

            {status === 'success' && (
                <div style={cardStyle}>
                    <div style={{ width: '80px', height: '80px', borderRadius: '50%',
                        background: 'rgba(102,190,99,0.2)', border: '2px solid #66BE63',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 1.5rem', fontSize: '2.5rem' }}>✅</div>

                    {isUpgrade ? (
                        <>
                            <h1 style={{ fontSize: '1.8rem', fontWeight: 900, color: '#002335', margin: '0 0 0.8rem' }}>
                                Abonnement mis à jour !
                            </h1>
                            <p style={{ color: '#4a6070', fontSize: '1rem', lineHeight: 1.6, marginBottom: '1.5rem' }}>
                                Votre nouvel abonnement est actif.<br />
                                Redirection vers votre espace dans quelques secondes...
                            </p>
                            <div style={infoBox}>
                                <strong style={{ color: '#002335' }}>Ce qui change :</strong><br />
                                • Votre offre est immédiatement active<br />
                                • Vos nouveaux écrans sont disponibles<br />
                                • La facturation est visible dans Mon Abonnement
                            </div>
                            <button onClick={() => history.push('/pricing?success=1')} style={btnBlue}>
                                Voir mon abonnement →
                            </button>
                        </>
                    ) : (
                        <>
                            <h1 style={{ fontSize: '1.8rem', fontWeight: 900, color: '#002335', margin: '0 0 0.8rem' }}>
                                Bienvenue sur SEIZO !
                            </h1>
                            <p style={{ color: '#4a6070', fontSize: '1rem', lineHeight: 1.6, marginBottom: '1.5rem' }}>
                                Votre abonnement a bien été activé.
                                {email && (
                                    <><br />Un email de confirmation a été envoyé à{' '}
                                        <strong style={{ color: '#002335' }}>{email}</strong>.
                                    </>
                                )}
                            </p>
                            <div style={infoBox}>
                                <strong style={{ color: '#002335' }}>Prochaines étapes :</strong><br />
                                1. Vérifiez votre boîte email et connectez-vous via le lien reçu<br />
                                2. Connectez-vous à votre espace SEIZO<br />
                                3. Configurez votre premier écran d'affichage
                            </div>
                            <button onClick={() => history.push('/')} style={btnBlue}>
                                Se connecter à mon espace SEIZO →
                            </button>
                        </>
                    )}
                </div>
            )}

            {status === 'error' && (
                <div style={{ ...cardStyle, border: '1px solid rgba(248,33,33,0.3)' }}>
                    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</div>
                    <h2 style={{ color: '#002335', marginBottom: '0.8rem' }}>Vérification impossible</h2>
                    <p style={{ color: '#6b8090', marginBottom: '1.5rem', lineHeight: 1.6 }}>
                        Nous n'avons pas pu confirmer votre paiement.
                        Si vous avez été débité, votre compte sera activé automatiquement dans quelques minutes.
                    </p>
                    <div style={{ display: 'flex', gap: '0.8rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <button onClick={() => history.push('/pricing')} style={{ ...btnBlue, width: 'auto', padding: '0.8rem 2rem' }}>
                            Retour aux offres
                        </button>
                        <button onClick={() => history.push('/')} style={{
                            background: 'transparent', color: '#4a6070',
                            border: '1px solid rgba(255,255,255,0.3)',
                            borderRadius: '10px', padding: '0.8rem 2rem', fontWeight: 600, cursor: 'pointer',
                        }}>
                            Se connecter
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AbonnementSuccess;
